// import React from "react";
// import {
//   Layout,
//   Button,
//   Card,
//   Form,
//   Input,
//   message
// } from "antd";
// import axios from 'axios';
// import logo1 from "../assets/images/logo1.png";
// import { useHistory } from "react-router-dom";
// import { baseUrl } from "../config";


// const { Content } = Layout;

// function SignIn() {
//   const history = useHistory();

//   const onFinish = async (values) => {
//     try {
//       const response = await axios.post(`${baseUrl}/login`, values);
//       console.log("Success:", response.data);
//       if (response.data.status === 'success') {
//         message.success(response.data.message);
//         localStorage.setItem('accessToken', response.data.user.token);
//         localStorage.setItem('permission', JSON.stringify(response.data.user.permission));
//         localStorage.setItem('userType', response.data.user.userType);
//         localStorage.setItem('firstName', response.data.user.firstName);
//         localStorage.setItem('lastName', response.data.user.lastName === undefined ? '' : response.data.user.lastName);
//         localStorage.setItem('userId', response.data.user._id);
//         localStorage.setItem('email', response.data.user.local.email);
//         history.push('/dashboard');
//       } else {
//         message.error(response.data.message);
//       }
//       // Do something with the successful response, like updating state or redirecting the user
//     } catch (error) {
//       console.log("Failed:", error.response.data);
//       message.error(error.response.data.message);
//       // Handle the error, display a message to the user, or perform any other action
//     }
//   };

//   const onFinishFailed = (errorInfo) => {
//     console.log("Failed:", errorInfo);
//     // Handle the failed form submission
//   };
//   return (
//     <>
//       <div className="layout-default ant-layout layout-sign-up">


//         <Content className="p-0">
//           <div className="sign-up-header">
//             <div className="content">
//               {/* <Title>LOGIN</Title> */}
//               {/* <p className="text-lg">
//                   Use these awesome forms to login or create new account in your
//                   project for free.
//                 </p> */}
//             </div>
//           </div>

//           <Card
//             className="card-signup header-solid ant-card pt-0"
//             title={<img className="login-image-logo" src={logo1} />}
//             bordered="false"
//           >
//             <Form
//               onFinish={onFinish}
//               onFinishFailed={onFinishFailed}
//               layout="vertical"
//               className="row-col"
//             >

//               <Form.Item
//                 className="username"
//                 label="Email"
//                 name="email"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your email!",
//                   },
//                 ]}
//               >
//                 <Input placeholder="Email" />
//               </Form.Item>
//               <Form.Item
//                 className="username"
//                 label="Password"
//                 name="password"
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please input your password!",
//                   },
//                 ]}
//               >
//                 <Input type="password" placeholder="Password" />
//               </Form.Item>

//               {/* <Form.Item name="remember" valuePropName="checked">
//                   <Checkbox>
//                     I agree the{" "}
//                     <a href="#pablo" className="font-bold text-dark">
//                       Terms and Conditions
//                     </a>
//                   </Checkbox>
//                 </Form.Item> */}

//               <Form.Item>
//                 <Button
//                   style={{ width: "100%" }}
//                   type="primary"
//                   htmlType="submit"
//                 >
//                   LOGIN
//                 </Button>
//               </Form.Item>
//             </Form>
//             {/* <p className="font-semibold text-muted text-center">
//                 Already have an account?{" "}
//                 <Link to="/sign-in" className="font-bold text-dark">
//                   Sign In
//                 </Link>
//               </p> */}
//           </Card>
//         </Content>

//       </div>
//     </>
//   );
// }

// export default SignIn;


import { useState, useEffect, useRef } from "react";
import { Layout, Button, Card, Form, Input, message, Select } from "antd";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { baseUrl } from "../config";

const kheteshwarLogo = process.env.PUBLIC_URL + '/Shri_Kheteshwar.jpg';

const { Content } = Layout;
const { Option } = Select;

function SignIn() {
  const history = useHistory();
  const inputRefs = useRef([]);
  const [isOtpSent, setIsOtpSent] = useState(false); // Track if OTP is sent
  const [loginData, setLoginData] = useState({}); // Store login info
  const [otpForm] = Form.useForm(); // Form instance for OTP
  const [mainForm] = Form.useForm(); // Form instance for main login
  const [remainingTime, setRemainingTime] = useState(120);
  const [isTimerActive, setIsTimerActive] = useState(false); // eslint-disable-line no-unused-vars
  const [otp, setOtp] = useState('');

  useEffect(() => {
    if (isOtpSent && remainingTime > 0) {
      const timer = setInterval(() => {
        setRemainingTime((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timer); // Clear timer when component unmounts or time changes
    } else if (remainingTime === 0) {
      message.error("OTP expired! Please resend the OTP.");
      setIsTimerActive(false); // Disable verification after timeout
    }
  }, [isOtpSent, remainingTime]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };

  const sendOtp = async (values) => {
    try {
      const response = await axios.post(`${baseUrl}/login/send-otp`, values); // Request OTP
      if (response.data.status) {
        message.success(response.data.message);
        setIsOtpSent(true); // Show OTP form
        setLoginData(values); // Store the login data to use later for verification
        setRemainingTime(120); // Reset the timer to 2 minutes
        setIsTimerActive(true); // Activate the timer
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("OTP Request Failed:", error.response?.data);
      message.error(error.response?.data?.message || "OTP request failed");
    }
  };

  const verifyOtp = async () => {
    if (remainingTime === 0) {
      message.error("OTP expire हो गया! कृपया दोबारा OTP भेजें।");
      return;
    }

    try {
      const response = await axios.post(`${baseUrl}/login`, {
        ...loginData, // Pass the login data (email/phone and password)
        otp: otp, // OTP entered by the user
      });
      if (response.data.status === "success") {
        message.success(response.data.message);
        localStorage.setItem("accessToken", response.data.user.token);
        localStorage.setItem("permission", JSON.stringify(response.data.user.permission));
        localStorage.setItem("userType", response.data.user.userType);
        localStorage.setItem("firstName", response.data.user.firstName);
        localStorage.setItem("lastName", response.data.user.lastName || "");
        localStorage.setItem("userId", response.data.user._id);
        localStorage.setItem("email", response.data.user.local.email);
        history.push("/dashboard");
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error("OTP Verification Failed:", error.response?.data);
      message.error(error.response?.data?.message || "OTP verification failed");
    }
  };

  const handleInputChange = (index, event) => {
    const value = event.target.value;

    if (value.length > 1) {
      // Handle paste — fill all 6 boxes
      const digits = value.replace(/\D/g, '').split('').slice(0, 6);
      digits.forEach((digit, idx) => {
        if (inputRefs.current[index + idx]) {
          inputRefs.current[index + idx].value = digit;
        }
      });
      const newOtp = digits.join('');
      setOtp(newOtp);
      otpForm.setFieldsValue({ otp: newOtp });
      inputRefs.current[Math.min(index + digits.length - 1, 5)]?.focus();
      return;
    }

    // Single digit — move focus forward
    if (value.length === 1 && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }

    setOtp(prev => {
      const chars = prev.padEnd(6, ' ').split('');
      chars[index] = value.charAt(0) || ' ';
      const newOtp = chars.join('').trim();
      otpForm.setFieldsValue({ otp: newOtp });
      return newOtp;
    });
  };

  const handleKeyDown = (index, event) => {
    if (event.key === 'Backspace') {
      if (!event.target.value && index > 0) {
        // Move to the previous input if backspacing from an empty input
        inputRefs.current[index - 1].focus();
      }
    }
  };

  return (
    <>
      <div className="layout-default ant-layout layout-sign-up">
        <Content className="p-0">
          <div className="sign-up-header">
            <div className="content"></div>
          </div>

          <Card className="card-signup header-solid ant-card pt-0" bordered={false}>

            {/* Avatar + org name — centred inside card */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{
                width: 100, height: 100,
                borderRadius: '50%',
                overflow: 'hidden',
                border: '3px solid #7a0000',
                margin: '0 auto 12px',
                boxShadow: '0 4px 14px rgba(26,46,74,0.18)',
              }}>
                <img
                  src={kheteshwarLogo}
                  alt="Shri Kheteshwar Brahmdham Tirth"
                  style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'top center', display: 'block' }}
                />
              </div>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#7a0000', lineHeight: 1.5 }}>
                अखिल भारतीय राजपुरोहित समाज विकास संस्थान
              </div>
              <div style={{ fontSize: 11, color: '#999', marginTop: 2, letterSpacing: '0.5px' }}>
                ABRSVS Admin Portal
              </div>
            </div>

            {!isOtpSent ? (
              // Initial Login Form
              <Form
                form={mainForm}
                onFinish={sendOtp}
                layout="vertical"
                className="row-col"
              >
                {/* Select branch field */}
                <Form.Item
                  className="branch"
                  label="Select Branch"
                  name="branch"
                  initialValue="branch1"
                  rules={[{ required: true, message: "Please select your branch!" }]}
                >
                  <Select>
                    <Option value="branch1">ABRSVS - SN (Head)</Option>
                  </Select>
                </Form.Item>

                <Form.Item
                  className="username"
                  label="Email or Phone"
                  name="identifier" // Single field for both email or phone
                  rules={[
                    { required: true, message: "Please input your email or phone!" },
                  ]}
                >
                  <Input placeholder="Email or Phone" />
                </Form.Item>
                <Form.Item
                  className="password"
                  label="Password"
                  name="password"
                  rules={[
                    { required: true, message: "Please input your password!" },
                  ]}
                >
                  <Input type="password" placeholder="Password" />
                </Form.Item>
                <Form.Item>
                  <Button style={{ width: "100%" }} type="primary" htmlType="submit">
                    Send OTP
                  </Button>
                </Form.Item>
              </Form>
            ) : (
              // OTP Form with Timer
              <Form
                form={otpForm}
                onFinish={verifyOtp}
                layout="vertical"
                className="row-col"
              >
                <p>Time remaining: {formatTime(remainingTime)}</p> {/* Timer display */}
                {/* <Form.Item
                  className="otp"
                  label="OTP"
                  name="otp"
                  rules={[
                    { required: true, message: "Please input the OTP!" },
                  ]}
                >
                  <Input placeholder="Enter OTP" />
                </Form.Item> */}
                <Form.Item label="OTP" name="otp" rules={[{ required: true, message: "कृपया OTP दर्ज करें!" }]}>
                  <div style={{ display: 'flex', gap: 10 }}>
                    {Array.from({ length: 6 }).map((_, index) => (
                      <input
                        key={index}
                        ref={el => (inputRefs.current[index] = el)}
                        maxLength={1}
                        placeholder="—"
                        onChange={(e) => handleInputChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                        onFocus={(e) => e.target.select()}
                        style={{
                          width: 44, height: 48,
                          textAlign: 'center', fontSize: 22, fontWeight: 700,
                          border: '1.5px solid #d9d9d9', borderRadius: 8,
                          outline: 'none', flex: 1,
                        }}
                        onFocusCapture={e => { e.target.style.borderColor = '#1890ff'; }}
                        onBlur={e => { e.target.style.borderColor = '#d9d9d9'; }}
                      />
                    ))}
                  </div>
                </Form.Item>

                <Form.Item>
                  <Button
                    style={{ width: "100%" }}
                    type="primary"
                    htmlType="submit"
                    disabled={remainingTime === 0} // Disable button when timer reaches 0
                  >
                    Verify OTP
                  </Button>
                </Form.Item>
              </Form>
            )}
            {/* Footer — inside card so it stays centred */}
            <div style={{
              textAlign: 'center', marginTop: 20, paddingTop: 14,
              borderTop: '1px solid #f0f0f0',
              fontSize: 11, color: '#bbb', letterSpacing: '0.3px',
            }}>
              Build &amp; Powered by{' '}
              <span style={{ color: '#7a0000', fontWeight: 600 }}>
                Akhil Bhartiya Rajpurohit Samaj Vikas Sansthan
              </span>
            </div>

          </Card>
        </Content>
      </div>
    </>
  );
}

export default SignIn;